import { writable, get } from 'svelte/store';

// 기본 스토어
const iframeRefWritable = writable(null);

// 최신값을 항상 제공하는 스토어
export const iframeRefStore = {
    subscribe: iframeRefWritable.subscribe,
	set: iframeRefWritable.set,
	get: () => get(iframeRefWritable),
};